/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { verificationTypeEnumSchema } from "./verificationTypeEnumSchema.ts";

export const verifyMethodSchema = z
	.object({
		id: z.uuid(),
		method: z.string(),
		verification_type: verificationTypeEnumSchema.optional().describe("* `login` - Login\n* `register` - Register\n* `delete_account` - Delete Account"),
	})
	.describe("Сериализатор ответа успешной отправки ОТП-кода.");
